<div
  *renderingPermissionDirective="[
    'FirmwareAdmin',
    'FirmwareReader',
    'FirmwareWriter',
    'ModuleUpdateAdmin',
    'ModuleUpdateReader',
    'ModuleUpdateWriter',
  ]"
  class="cohorts">
  <div class="cohorts__content">
    <span class="cohorts__grid-title lx-section-title">cohorts</span>

    <dcc-cohort-query
      class="cohorts-metrics"
      [query]="query"
      [total]="cohorts.length"
      (updateQuery)="updateQuery()"></dcc-cohort-query>

    <div class="cohorts-create">
      <button
        class="lx-btn-small lx-btn-primary"
        (click)="createCohort()">
        Create Cohort
      </button>
    </div>

    <ag-grid-angular
      #cohortsGrid
      class="cohorts__data ag-theme-alpine ag-grid-sticky-header"
      domLayout="autoHeight"
      rowSelection="single"
      style="width: auto; height: 100%"
      [columnDefs]="columns"
      [defaultColDef]="defaultColDef"
      [enableCellTextSelection]="true"
      [ensureDomOrder]="true"
      [rowData]="pagedCohorts[currentPage]"
      [suppressRowHoverHighlight]="true"></ag-grid-angular>

    <dcc-footer-items-dropdown
      [pageSize]="pageSize"
      (changedPageSize)="selectPageSize($event)"></dcc-footer-items-dropdown>

    <paginator
      class="cohorts__pagination_container__page-select"
      [currentPageNumber]="currentPage"
      [endOfSet]="currentPage === pageCount"
      [pageNumbers]="pageCount"
      (selectedPage)="selectPage($event)"></paginator>
  </div>
</div>
